import { Button, Icon } from "@chakra-ui/react";
import { type ChainFullId, type Network, getChainFullIdFromNetwork } from "@umami/chains";

import { ChainIconWithName } from "../Token/ChainIconWithName";

import { ChevronRightIcon } from "@/assets/icons";
import { useColor } from "@/styles/useColor";
export const NETWORK_SELECTOR_ITEM_HEIGHT = 48;
export const NETWORK_SELECTOR_ITEM_MARGIN_BOTTOM = 5;
export const NetworkSelectorItem = ({
  chain,
  name,
  onSelectChain,
}: {
  chain: Network;
  name?: string;
  onSelectChain: (chainId: ChainFullId) => void;
}) => {
  const chainId = getChainFullIdFromNetwork(chain);
  const color = useColor();

  return (
    <Button
      alignItems="center"
      justifyContent="space-between"
      gap="10px"
      width="full"
      height={`${NETWORK_SELECTOR_ITEM_HEIGHT}px`}
      marginBottom={`${NETWORK_SELECTOR_ITEM_MARGIN_BOTTOM}px`}
      padding="8px"
      color={color("400")}
      data-group
      onClick={() => onSelectChain(getChainFullIdFromNetwork(chain))}
      variant="dropdownOption"
    >
      <ChainIconWithName chainId={chainId} name={name} />
      <Icon as={ChevronRightIcon} width="24px" height="24px" color={color("600")} />
    </Button>
  );
};
